import { useState, useEffect, useCallback, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import api from "../api/client";

const CSS = `
*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
:root {
  --bg: #f0f4fc; --surface: #ffffff; --surface2: #f4f8ff;
  --border: #c0d0eb; --border2: #d5e3f5;
  --accent: #b45309; --text: #0d1a36; --text2: #2a4a78; --muted: #6080aa;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif;
  color-scheme: light;
}
body { background: var(--bg); color: var(--text); }
.adm-topbar { position: sticky; top: 0; z-index: 100; height: 52px; display: flex; align-items: center; background: rgba(240,244,252,.92); backdrop-filter: blur(12px); border-bottom: 1px solid var(--border2); }
.adm-back { width: 52px; height: 52px; display: flex; align-items: center; justify-content: center; background: none; border: none; border-right: 1px solid var(--border2); color: var(--text2); cursor: pointer; font-size: 16px; flex-shrink: 0; transition: color .15s, background .15s; }
.adm-back:hover { color: var(--text); background: var(--surface); }
.adm-brand { display: flex; align-items: center; gap: 10px; padding: 0 20px; flex: 1; }
.adm-brand-mark { width: 26px; height: 26px; border-radius: 6px; background: linear-gradient(135deg, #b45309, #dc2626); display: flex; align-items: center; justify-content: center; font-size: 13px; }
.adm-brand-label { font-size: 14px; font-weight: 600; color: var(--text); }
.adm-avatar { margin-right: 16px; width: 30px; height: 30px; border-radius: 50%; background: linear-gradient(135deg, #2563eb, #7c3aed); display: flex; align-items: center; justify-content: center; font-size: 11px; font-weight: 700; color: #fff; flex-shrink: 0; }
.adm-tabs { display: flex; align-items: center; gap: 2px; padding: 0 20px; border-bottom: 1px solid var(--border2); background: var(--surface); overflow-x: auto; }
.adm-tab { padding: 14px 16px; font-size: 13px; font-weight: 500; color: var(--muted); background: none; border: none; cursor: pointer; border-bottom: 2px solid transparent; margin-bottom: -1px; transition: color .15s; font-family: inherit; white-space: nowrap; }
.adm-tab:hover { color: var(--text2); }
.adm-tab.active { color: var(--accent); border-bottom-color: var(--accent); }
.adm-main { max-width: 1200px; margin: 0 auto; padding: 28px 24px 80px; }
.adm-metrics { display: grid; grid-template-columns: repeat(4,1fr); gap: 12px; margin-bottom: 20px; }
@media(max-width:800px){ .adm-metrics{ grid-template-columns:repeat(2,1fr); } }
.adm-metric { background: var(--surface); border: 1px solid var(--border); border-radius: 10px; padding: 18px 20px; }
.adm-metric-label { font-size: 11px; font-weight: 600; letter-spacing: .06em; text-transform: uppercase; color: var(--muted); margin-bottom: 6px; }
.adm-metric-value { font-size: 24px; font-weight: 700; letter-spacing: -.02em; }
.adm-metric-sub { font-size: 11px; color: var(--muted); margin-top: 4px; }
.adm-card { background: var(--surface); border: 1px solid var(--border); border-radius: 10px; padding: 20px; margin-bottom: 14px; }
.adm-card-title { font-size: 14px; font-weight: 600; color: var(--text); margin-bottom: 16px; display: flex; align-items: center; justify-content: space-between; }
.adm-table-wrap { overflow-x: auto; }
.adm-table { width: 100%; border-collapse: collapse; min-width: 480px; }
.adm-table th { font-size: 10px; font-weight: 600; letter-spacing: .07em; text-transform: uppercase; color: var(--muted); padding: 0 12px 10px; text-align: left; border-bottom: 1px solid var(--border2); white-space: nowrap; }
.adm-table td { padding: 11px 12px; font-size: 13px; color: var(--text2); border-bottom: 1px solid var(--border2); vertical-align: middle; }
.adm-table tr:last-child td { border-bottom: none; }
.adm-table tr:hover td { background: var(--surface2); }
.adm-badge { display: inline-flex; align-items: center; gap: 4px; padding: 3px 8px; border-radius: 20px; font-size: 10px; font-weight: 600; letter-spacing: .05em; text-transform: uppercase; border: 1px solid; white-space: nowrap; }
.adm-badge-dot { width: 5px; height: 5px; border-radius: 50%; background: currentColor; flex-shrink: 0; }
.adm-action-btn { background: none; border: 1px solid var(--border); border-radius: 6px; padding: 4px 9px; font-size: 11px; color: var(--text2); cursor: pointer; font-family: inherit; transition: border-color .15s, color .15s; margin-right: 4px; white-space: nowrap; }
.adm-action-btn:hover { border-color: var(--accent); color: var(--accent); }
.adm-action-btn.danger:hover { border-color: #dc2626; color: #dc2626; }
.adm-action-btn.active-btn { border-color: #059669; color: #059669; }
.adm-form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
@media(max-width:600px){ .adm-form-grid{ grid-template-columns:1fr; } }
.adm-field { display: flex; flex-direction: column; gap: 6px; }
.adm-label { font-size: 11px; font-weight: 600; letter-spacing: .05em; text-transform: uppercase; color: var(--muted); }
.adm-input { background: var(--surface2); border: 1px solid var(--border2); border-radius: 7px; padding: 9px 12px; font-size: 13px; color: var(--text); outline: none; font-family: inherit; transition: border-color .15s; }
.adm-input:focus { border-color: var(--accent); }
.adm-select { background: var(--surface2); border: 1px solid var(--border2); border-radius: 7px; padding: 9px 12px; font-size: 13px; color: var(--text); outline: none; font-family: inherit; cursor: pointer; }
.adm-submit { margin-top: 16px; padding: 10px 24px; border-radius: 7px; background: var(--accent); border: none; color: #000; font-size: 13px; font-weight: 700; cursor: pointer; font-family: inherit; transition: opacity .15s; }
.adm-submit:hover { opacity: .85; }
.adm-submit:disabled { opacity: .5; cursor: not-allowed; }
.adm-log-row { display: flex; gap: 12px; align-items: flex-start; padding: 10px 0; border-bottom: 1px solid var(--border2); }
.adm-log-row:last-child { border-bottom: none; }
.adm-log-time { font-size: 11px; color: var(--muted); white-space: nowrap; flex-shrink: 0; width: 130px; font-variant-numeric: tabular-nums; }
.adm-log-action { font-size: 12px; color: var(--accent); font-weight: 600; min-width: 120px; flex-shrink: 0; }
.adm-log-msg { font-size: 13px; color: var(--text2); flex: 1; }
.adm-log-user { font-size: 11px; color: var(--muted); margin-top: 2px; }
.adm-toggle { display: flex; align-items: center; justify-content: space-between; padding: 14px 0; border-bottom: 1px solid var(--border2); }
.adm-toggle:last-child { border-bottom: none; }
.adm-toggle-name { font-size: 13px; color: var(--text); font-weight: 500; }
.adm-toggle-desc { font-size: 12px; color: var(--muted); margin-top: 3px; }
.adm-switch { position: relative; width: 36px; height: 20px; flex-shrink: 0; }
.adm-switch input { opacity: 0; width: 0; height: 0; }
.adm-slider { position: absolute; inset: 0; cursor: pointer; background: var(--border); border-radius: 20px; transition: background .2s; }
.adm-slider:before { content: ''; position: absolute; width: 14px; height: 14px; border-radius: 50%; left: 3px; top: 3px; background: #fff; transition: transform .2s; }
.adm-switch input:checked + .adm-slider { background: var(--accent); }
.adm-switch input:checked + .adm-slider:before { transform: translateX(16px); }
.adm-section-btn { background: none; border: 1px solid var(--accent); border-radius: 7px; padding: 7px 14px; font-size: 12px; color: var(--accent); cursor: pointer; font-family: inherit; font-weight: 600; transition: background .15s; }
.adm-section-btn:hover { background: rgba(245,158,11,.1); }
.adm-inline-form { background: var(--surface2); border: 1px solid var(--border); border-radius: 10px; padding: 20px; margin-bottom: 14px; }
.adm-inline-form-title { font-size: 13px; font-weight: 600; color: var(--text); margin-bottom: 14px; }
.adm-access-row { display: flex; align-items: center; justify-content: space-between; padding: 12px 0; border-bottom: 1px solid var(--border2); }
.adm-access-row:last-child { border-bottom: none; }
.adm-access-label { font-size: 13px; color: var(--text2); }
.adm-error { padding: 10px 14px; border-radius: 7px; background: rgba(248,113,113,.08); border: 1px solid rgba(248,113,113,.2); color: #dc2626; font-size: 13px; margin-bottom: 14px; }
.adm-success { padding: 10px 14px; border-radius: 7px; background: rgba(16,185,129,.08); border: 1px solid rgba(16,185,129,.2); color: #059669; font-size: 13px; margin-bottom: 14px; }
.adm-spinner-wrap { display: flex; justify-content: center; align-items: center; height: 200px; }
.adm-spinner { width: 32px; height: 32px; border: 3px solid var(--border); border-top-color: var(--accent); border-radius: 50%; animation: aspin .6s linear infinite; }
@keyframes aspin { to { transform: rotate(360deg); } }
.adm-empty { font-size: 13px; color: var(--muted); padding: 20px 0; }
.adm-progress-track { flex: 1; height: 6px; background: var(--border); border-radius: 3px; overflow: hidden; margin: 0 12px; }
.adm-progress-fill { height: 100%; border-radius: 3px; background: var(--accent); transition: width .4s; }
.adm-checkbox-row { display: flex; align-items: center; gap: 8px; padding: 6px 0; }
.adm-checkbox-row label { font-size: 13px; color: var(--text2); cursor: pointer; }
`;

const ROLE_COLOR = {
  super_admin: { color: "#dc2626", bg: "rgba(248,113,113,.08)", border: "rgba(248,113,113,.2)" },
  admin:       { color: "#b45309", bg: "rgba(245,158,11,.1)",   border: "rgba(245,158,11,.25)" },
  manager:     { color: "#2563eb", bg: "rgba(64,119,244,.1)",   border: "rgba(64,119,244,.25)" },
  hr_admin:    { color: "#0284c7", bg: "rgba(2,132,199,.1)",    border: "rgba(2,132,199,.25)"  },
  payroll_approver: { color: "#059669", bg: "rgba(16,185,129,.1)", border: "rgba(16,185,129,.25)" },
  viewer_auditor:   { color: "#6080aa", bg: "rgba(96,128,170,.1)",  border: "rgba(96,128,170,.25)" },
  user:        { color: "#2a4a78", bg: "rgba(140,163,200,.08)", border: "rgba(140,163,200,.2)"  },
};
const STATUS_COLOR = {
  active:   { color: "#059669", bg: "rgba(16,185,129,.1)",   border: "rgba(16,185,129,.25)"  },
  inactive: { color: "#dc2626", bg: "rgba(248,113,113,.08)", border: "rgba(248,113,113,.2)"  },
};

// Keep in sync with MODEL_PRICING in AI agent backend/utils/ai_gateway.py — a
// model picked here must have a matching cost entry there. $ per 1M tokens.
const MODEL_PRICING_DISPLAY = {
  "gpt-4o":      { input: 2.50, output: 10.00 },
  "gpt-4o-mini": { input: 0.15, output: 0.60 },
  "gpt-5":       { input: 1.25, output: 10.00 },
  "gpt-5-mini":  { input: 0.25, output: 2.00 },
  "gpt-5-nano":  { input: 0.05, output: 0.40 },
  "gpt-6-luna":  { input: 0.10, output: 0.50 },
};
const MODEL_OPTIONS = Object.keys(MODEL_PRICING_DISPLAY);

function ModelPriceHint({ model }) {
  const rate = MODEL_PRICING_DISPLAY[model];
  if (!rate) return null;
  return (
    <div style={{ fontSize: 11, color: "#2a4a78", marginTop: 4 }}>
      ${rate.input.toFixed(2)} in / ${rate.output.toFixed(2)} out per 1M tokens
    </div>
  );
}

function Badge({ label, type, colorMap }) {
  const c = colorMap[type] || colorMap.user || colorMap.active;
  return (
    <span className="adm-badge" style={{ color: c.color, background: c.bg, borderColor: c.border }}>
      <span className="adm-badge-dot" />
      {label}
    </span>
  );
}

const ACTION_LABELS = {
  login_success:      "Login Success",
  login_denied:       "Login Denied",
  org_created:        "Org Created",
  org_edited:         "Org Edited",
  org_suspended:      "Org Suspended",
  org_activated:      "Org Activated",
  org_deleted:        "Org Deleted",
  org_access_changed: "Org Access Changed",
  org_limits_changed: "Org Limits Changed",
  user_created:       "User Created",
  user_edited:        "User Edited",
  user_suspended:     "User Suspended",
  user_activated:     "User Activated",
  user_deleted:       "User Deleted",
};

export default function Admin() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const isSuperAdmin = user?.role === "super_admin";
  const isAdmin = user?.role === "admin" || isSuperAdmin;

  // Tab list depends on role
  const getOrgAccess = (org_id) => {
    if (isSuperAdmin) {
      const org = orgs.find(o => o.id === org_id);
      return org || { access_bizcard: true, access_email: true, access_compliance: true, access_expense: true, access_hrms: true, access_bni: true};
    }
    return users[0]?.organisations || { access_bizcard: true, access_email: true, access_compliance: true, access_expense: true, access_hrms: true, access_bni: true};
  };

  const TABS = isSuperAdmin
    ? ["Overview", "Company Profile", "Organisations", "Users", "Usage", "Audit Logs", "Billing", "AI Pricing", "AI Agents", "Credit Wallets", "AI Dashboard"]
    : ["Overview", "Company Profile", "Users", "Usage", "Audit Logs", "Billing"];

  const [tab, setTab] = useState(0);
  const [orgs, setOrgs] = useState([]);
  const [users, setUsers] = useState([]);
  const [usage, setUsage] = useState([]);
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [msg, setMsg] = useState("");

  // Org panel state
  const [orgAction, setOrgAction] = useState(null); // { type, org }
  const [orgForm, setOrgForm] = useState({});

  // Company Profile (self-service, own org only)
  const [myOrg, setMyOrg] = useState(null);
  const [myOrgForm, setMyOrgForm] = useState({});
  const [myOrgMsg, setMyOrgMsg] = useState("");

  // User panel state
  const [showAddUser, setShowAddUser] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [newUser, setNewUser] = useState({ name: "", email: "", org_id: "", role: "user", access_bizcard: true, access_email: true, access_compliance: true, access_expense: true, access_hrms: true, access_bni: true});

  // Audit filter
  const [auditAction, setAuditAction] = useState("");
  const [auditLimit, setAuditLimit] = useState(100);

  // Billing state (org-facing)
  const [wallet, setWallet] = useState(null);
  const [topups, setTopups] = useState([]);
  const [topupAmount, setTopupAmount] = useState("");
  const [topupRemarks, setTopupRemarks] = useState("");

  // Billing state (super-admin)
  const [agentConfigs, setAgentConfigs] = useState([]);
  const [agentDrafts, setAgentDrafts] = useState({});
  const [pricing, setPricing] = useState(null);
  const [pricingDraft, setPricingDraft] = useState({ global_cost_multiplier: "", credit_conversion_rate: "", default_model: "", usd_to_omr_rate: "" });
  const [allWallets, setAllWallets] = useState([]);
  const [allTopups, setAllTopups] = useState([]);
  const [historyOrgId, setHistoryOrgId] = useState(null);
  const [walletHistory, setWalletHistory] = useState([]);
  const [usageLogs, setUsageLogs] = useState([]);
  const [platformSummary, setPlatformSummary] = useState(null);
  const [userSummary, setUserSummary] = useState([]);
  const [agentSummary, setAgentSummary] = useState([]);

  const initials = (user?.name || "A").split(" ").map(w => w[0]).join("").slice(0, 2).toUpperCase();

  const flash = (m, isErr=false) => { const s = typeof m === 'string' ? m : (Array.isArray(m) ? m.map(e=>e.msg||JSON.stringify(e)).join(', ') : JSON.stringify(m)); if(isErr) setError(s); else setMsg(s); setTimeout(() => { setError(""); setMsg(""); }, 3000); };

  const loadAll = useCallback(async () => {
    setLoading(true);
    try {
      const calls = [api.get("/admin/users"), api.get("/admin/usage")];
      if (isSuperAdmin) calls.push(api.get("/admin/organisations"));
      const results = await Promise.all(calls);
      setUsers(results[0].data);
      setUsage(results[1].data);
      if (isSuperAdmin) setOrgs(results[2].data);
    } catch (e) {
      const det = e?.response?.data?.detail; setError(typeof det === 'string' ? det : det ? JSON.stringify(det) : 'Failed to load admin data');
    } finally {
      setLoading(false);
    }
  }, [isSuperAdmin]);

  const loadLogs = useCallback(async () => {
    try {
      const params = new URLSearchParams({ limit: auditLimit });
      if (auditAction) params.set("action", auditAction);
      const r = await api.get(`/admin/audit-logs?${params}`);
      setLogs(r.data);
    } catch (e) {
      const det2 = e?.response?.data?.detail; setError(typeof det2 === 'string' ? det2 : 'Failed to load audit logs');
    }
  }, [auditAction, auditLimit]);

  const loadMyOrg = useCallback(async () => {
    try {
      const r = await api.get("/admin/organisations/me");
      setMyOrg(r.data);
      setMyOrgForm(r.data);
    } catch (e) { flash(e?.response?.data?.detail || "Failed to load company profile", true); }
  }, []);

  const saveMyOrg = async () => {
    try {
      const { id, is_active, is_deleted, created_at, ...editable } = myOrgForm;
      await api.patch("/admin/organisations/me", editable);
      setMyOrgMsg("Company profile saved.");
      setTimeout(() => setMyOrgMsg(""), 3000);
      loadMyOrg();
    } catch (e) { flash(e?.response?.data?.detail || "Failed to save company profile", true); }
  };

  const loadBilling = useCallback(async () => {
    try {
      const [w, t] = await Promise.all([api.get("/billing/wallet"), api.get("/billing/topup-requests")]);
      setWallet(w.data); setTopups(t.data);
    } catch (e) { flash(e?.response?.data?.detail || "Failed to load billing", true); }
  }, []);

  const loadPricing = useCallback(async () => {
    try {
      const [ac, pr] = await Promise.all([api.get("/billing/agents"), api.get("/billing/pricing")]);
      setAgentConfigs(ac.data);
      const drafts = {};
      ac.data.forEach(a => { drafts[a.agent_slug] = {
        model_name: a.model_name || "",
        max_tokens_per_request: a.max_tokens_per_request ?? "",
        default_cost_multiplier: a.default_cost_multiplier ?? "",
        status: a.status,
      }; });
      setAgentDrafts(drafts);
      setPricing(pr.data);
      setPricingDraft({
        global_cost_multiplier: pr.data.global_cost_multiplier,
        credit_conversion_rate: pr.data.credit_conversion_rate,
        default_model: pr.data.default_model || "",
        usd_to_omr_rate: pr.data.usd_to_omr_rate,
      });
    } catch (e) { flash(e?.response?.data?.detail || "Failed to load pricing", true); }
  }, []);

  const loadWallets = useCallback(async () => {
    try {
      const [w, t] = await Promise.all([api.get("/billing/wallets"), api.get("/billing/topup-requests/all")]);
      setAllWallets(w.data); setAllTopups(t.data);
    } catch (e) { flash(e?.response?.data?.detail || "Failed to load wallets", true); }
  }, []);

  const loadUsageLogs = useCallback(async () => {
    try {
      const [logs, platform, users, agents] = await Promise.all([
        api.get("/billing/usage-logs"),
        api.get("/billing/dashboard/platform"),
        api.get("/billing/dashboard/users"),
        api.get("/billing/dashboard/agents"),
      ]);
      setUsageLogs(logs.data);
      setPlatformSummary(platform.data);
      setUserSummary(users.data);
      setAgentSummary(agents.data);
    } catch (e) { flash(e?.response?.data?.detail || "Failed to load usage logs", true); }
  }, []);

  useEffect(() => { loadAll(); }, [loadAll]);

  const activeCount = users.filter(u => u.is_active !== false).length;

  // ── Org actions ──
  const orgSave = async () => {
    try {
      if (orgAction.type === "add") {
        await api.post("/admin/organisations", orgForm);
        flash("Organisation created");
      } else if (orgAction.type === "edit") {
        await api.patch(`/admin/organisations/${orgAction.org.id}`, orgForm);
        flash("Organisation updated");
      } else if (orgAction.type === "access") {
        await api.patch(`/admin/organisations/${orgAction.org.id}/access`, orgForm);
        flash("Access updated");
      } else if (orgAction.type === "limits") {
        await api.patch(`/admin/organisations/${orgAction.org.id}/limits`, orgForm);
        flash("Limits saved");
      }
      setOrgAction(null);
      setOrgForm({});
      loadAll();
    } catch (e) { flash(e?.response?.data?.detail || "Error", true); }
  };

  const orgToggleSuspend = async (org) => {
    try {
      if (org.is_active) { await api.post(`/admin/organisations/${org.id}/suspend`); flash("Organisation suspended"); }
      else { await api.post(`/admin/organisations/${org.id}/activate`); flash("Organisation activated"); }
      loadAll();
    } catch (e) { flash(e?.response?.data?.detail || "Error", true); }
  };

  const orgDelete = async (org) => {
    if (!window.confirm(`Delete organisation "${org.name}"?`)) return;
    try { await api.delete(`/admin/organisations/${org.id}`); flash("Organisation deleted"); loadAll(); }
    catch (e) { flash(e?.response?.data?.detail || "Error", true); }
  };

  // ── User actions ──
  const addUser = async () => {
    if (!newUser.email) { flash("Email is required", true); return; }
    if (!newUser.org_id) { flash("Organisation is required", true); return; }
    try {
      await api.post("/admin/users", newUser);
      flash("User added");
      setShowAddUser(false);
      setNewUser({ name: "", email: "", org_id: orgs[0]?.id || "", role: "user", access_bizcard: true, access_email: true, access_compliance: true, access_expense: true, access_hrms: true, access_bni: true});
      loadAll();
    } catch (e) { flash(e?.response?.data?.detail || "Error", true); }
  };

  const saveUser = async () => {
    try {
      await api.patch(`/admin/users/${editingUser.id}`, editingUser);
      flash("User updated");
      setEditingUser(null);
      loadAll();
    } catch (e) { flash(e?.response?.data?.detail || "Error", true); }
  };

  const toggleUserStatus = async (u) => {
    try {
      if (u.is_active !== false) { await api.post(`/admin/users/${u.id}/suspend`); }
      else { await api.post(`/admin/users/${u.id}/activate`); }
      flash("User updated");
      loadAll();
    } catch (e) { flash(e?.response?.data?.detail || "Error", true); }
  };

  const deleteUser = async (u) => {
    if (!window.confirm(`Remove user "${u.email}"?`)) return;
    try { await api.delete(`/admin/users/${u.id}`); flash("User removed"); loadAll(); }
    catch (e) { flash(e?.response?.data?.detail || "Error", true); }
  };

  // ── Billing actions ──
  const submitTopup = async () => {
    if (!topupAmount || Number(topupAmount) <= 0) { flash("Enter a credit amount", true); return; }
    try {
      await api.post("/billing/topup-requests", { requested_credits: Number(topupAmount), remarks: topupRemarks || null });
      flash("Top-up request submitted");
      setTopupAmount(""); setTopupRemarks("");
      loadBilling();
    } catch (e) { flash(e?.response?.data?.detail || "Error", true); }
  };

  const saveAgentConfig = async (slug) => {
    const d = agentDrafts[slug];
    try {
      await api.put(`/billing/agents/${slug}`, {
        model_name: d.model_name || null,
        max_tokens_per_request: d.max_tokens_per_request === "" ? null : Number(d.max_tokens_per_request),
        default_cost_multiplier: d.default_cost_multiplier === "" ? null : Number(d.default_cost_multiplier),
        status: d.status,
      });
      flash("Agent updated");
      loadPricing();
    } catch (e) { flash(e?.response?.data?.detail || "Error", true); }
  };

  const savePricing = async () => {
    try {
      await api.put("/billing/pricing", {
        global_cost_multiplier: pricingDraft.global_cost_multiplier === "" ? null : Number(pricingDraft.global_cost_multiplier),
        credit_conversion_rate: pricingDraft.credit_conversion_rate === "" ? null : Number(pricingDraft.credit_conversion_rate),
        default_model: pricingDraft.default_model.trim() === "" ? null : pricingDraft.default_model.trim(),
        usd_to_omr_rate: pricingDraft.usd_to_omr_rate === "" ? null : Number(pricingDraft.usd_to_omr_rate),
      });
      flash("Pricing updated");
      loadPricing();
    } catch (e) { flash(e?.response?.data?.detail || "Error", true); }
  };

  const adjustWallet = async (orgId, action) => {
    let amount = null;
    if (action !== "reset") {
      const input = window.prompt(`Credits to ${action}:`);
      if (!input) return;
      amount = Number(input);
      if (!amount || amount <= 0) { flash("Enter a valid amount", true); return; }
    } else if (!window.confirm("Reset this wallet's total and used credits to 0?")) {
      return;
    }
    try {
      await api.post(`/billing/wallet/${orgId}/adjust`, { action, amount });
      flash("Wallet updated");
      loadWallets();
    } catch (e) { flash(e?.response?.data?.detail || "Error", true); }
  };

  const viewWalletHistory = async (orgId) => {
    if (historyOrgId === orgId) { setHistoryOrgId(null); return; }
    try {
      const r = await api.get(`/billing/wallet/${orgId}/history`);
      setWalletHistory(r.data);
      setHistoryOrgId(orgId);
    } catch (e) { flash(e?.response?.data?.detail || "Error", true); }
  };

  const setOrgMultiplier = async (orgId, currentValue) => {
    const input = window.prompt(
      "Cost multiplier for this organisation (e.g. 1.75). Leave blank and submit to clear the override and fall back to the global multiplier:",
      currentValue ?? ""
    );
    if (input === null) return; // cancelled
    const cost_multiplier = input.trim() === "" ? null : Number(input);
    if (input.trim() !== "" && (!cost_multiplier || cost_multiplier <= 0)) {
      flash("Enter a valid positive number, or leave blank to clear", true);
      return;
    }
    try {
      await api.put(`/billing/pricing/organisations/${orgId}`, { cost_multiplier });
      flash("Organisation multiplier updated");
      loadWallets();
    } catch (e) { flash(e?.response?.data?.detail || "Error", true); }
  };

  const approveTopup = async (id) => {
    try { await api.patch(`/billing/topup-requests/${id}/approve`); flash("Top-up approved"); loadWallets(); }
    catch (e) { flash(e?.response?.data?.detail || "Error", true); }
  };
  const rejectTopup = async (id) => {
    try { await api.patch(`/billing/topup-requests/${id}/reject`); flash("Top-up rejected"); loadWallets(); }
    catch (e) { flash(e?.response?.data?.detail || "Error", true); }
  };

  const exportCSV = (filename, columns, data) => {
    const escape = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
    const lines = [
      columns.map(c => escape(c.label)).join(","),
      ...data.map(row => columns.map(c => escape(row[c.key])).join(",")),
    ];
    const blob = new Blob([lines.join("\n")], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = filename;
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  if (!isAdmin) return (
    <div style={{ padding: 40, color: "#dc2626", fontFamily: "sans-serif" }}>
      Access denied — admin role required.
    </div>
  );

  return (
    <>
      <style>{CSS}</style>

      <header className="adm-topbar">
        <button className="adm-back" onClick={() => navigate("/")}>&#8592;</button>
        <div className="adm-brand">
          <div className="adm-brand-mark">&#9881;</div>
          <span className="adm-brand-label">Admin Panel</span>
        </div>
        <div style={{ marginRight: 8, fontSize: 12, color: "#6080aa" }}>{user?.org_name}</div>
        <div className="adm-avatar" title={user?.name}>{initials}</div>
      </header>

      <div className="adm-tabs">
        {TABS.map((t, i) => (
          <button key={t} className={`adm-tab${tab === i ? " active" : ""}`}
            onClick={() => {
              setTab(i);
              if (t === "Company Profile") loadMyOrg();
              else if (t === "Audit Logs") loadLogs();
              else if (t === "Billing") loadBilling();
              else if (t === "AI Pricing" || t === "AI Agents") loadPricing();
              else if (t === "Credit Wallets") loadWallets();
              else if (t === "AI Dashboard") loadUsageLogs();
            }}>{t}</button>
        ))}
      </div>

      <main className="adm-main">
        {error && <div className="adm-error">&#9888; {error}</div>}
        {msg   && <div className="adm-success">&#10003; {msg}</div>}

        {loading
          ? <div className="adm-spinner-wrap"><div className="adm-spinner"/></div>
          : <>

          {/* ── Overview ── */}
          {TABS[tab] === "Overview" && (
            <>
              <div className="adm-metrics">
                <div className="adm-metric">
                  <div className="adm-metric-label">Total Users</div>
                  <div className="adm-metric-value" style={{color:"#2563eb"}}>{users.length}</div>
                  <div className="adm-metric-sub">{activeCount} active</div>
                </div>
                <div className="adm-metric">
                  <div className="adm-metric-label">Active</div>
                  <div className="adm-metric-value" style={{color:"#059669"}}>{activeCount}</div>
                  <div className="adm-metric-sub">accounts</div>
                </div>
                <div className="adm-metric">
                  <div className="adm-metric-label">Inactive</div>
                  <div className="adm-metric-value" style={{color:"#dc2626"}}>{users.length - activeCount}</div>
                  <div className="adm-metric-sub">accounts</div>
                </div>
                {isSuperAdmin && (
                  <div className="adm-metric">
                    <div className="adm-metric-label">Organisations</div>
                    <div className="adm-metric-value" style={{color:"#b45309"}}>{orgs.length}</div>
                    <div className="adm-metric-sub">registered</div>
                  </div>
                )}
              </div>

              <div className="adm-card">
                <div className="adm-card-title">User Summary</div>
                <div className="adm-table-wrap">
                  <table className="adm-table">
                    <thead><tr><th>Name</th><th>Email</th><th>Role</th><th>Status</th>{isSuperAdmin && <th>Organisation</th>}</tr></thead>
                    <tbody>
                      {users.slice(0,10).map(u => (
                        <tr key={u.id}>
                          <td style={{color:"#0d1a36",fontWeight:500}}>{u.name || "—"}</td>
                          <td>{u.email}</td>
                          <td><Badge label={u.role} type={u.role} colorMap={ROLE_COLOR}/></td>
                          <td><Badge label={u.is_active!==false?"active":"inactive"} type={u.is_active!==false?"active":"inactive"} colorMap={STATUS_COLOR}/></td>
                          {isSuperAdmin && <td>{u.organisations?.name || "—"}</td>}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {usage.length > 0 && (
                <div className="adm-card">
                  <div className="adm-card-title">This Month — Token Usage</div>
                  {usage.map(o => (
                    <div key={o.id} style={{marginBottom:12}}>
                      <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:4}}>
                        <span style={{fontSize:13,color:"#0d1a36",flex:1}}>{o.name}</span>
                        <span style={{fontSize:12,color:"#6080aa",fontVariantNumeric:"tabular-nums"}}>{o.tokens.toLocaleString()} tokens · {o.requests.toLocaleString()} req</span>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </>
          )}

          {/* ── Company Profile (self-service, own org only) ── */}
          {TABS[tab] === "Company Profile" && (
            <div className="adm-card">
              <div className="adm-card-title">Company Profile — {myOrg?.name || user?.org_name}</div>
              {myOrgMsg && <div className="adm-success">&#10003; {myOrgMsg}</div>}
              {!myOrg ? (
                <div className="adm-spinner-wrap"><div className="adm-spinner" /></div>
              ) : (
                <>
                  <div className="adm-form-grid">
                    <div className="adm-field"><label className="adm-label">Company Name</label>
                      <input className="adm-input" value={myOrgForm.name || ""} onChange={e => setMyOrgForm(p => ({ ...p, name: e.target.value }))} /></div>
                    <div className="adm-field"><label className="adm-label">Company Name (Arabic)</label>
                      <input className="adm-input" value={myOrgForm.company_name_arabic || ""} onChange={e => setMyOrgForm(p => ({ ...p, company_name_arabic: e.target.value }))} /></div>
                    <div className="adm-field"><label className="adm-label">Contact Person</label>
                      <input className="adm-input" value={myOrgForm.contact_name || ""} onChange={e => setMyOrgForm(p => ({ ...p, contact_name: e.target.value }))} /></div>
                    <div className="adm-field"><label className="adm-label">Contact Email</label>
                      <input className="adm-input" type="email" value={myOrgForm.contact_email || ""} onChange={e => setMyOrgForm(p => ({ ...p, contact_email: e.target.value }))} /></div>
                    <div className="adm-field"><label className="adm-label">Phone</label>
                      <input className="adm-input" value={myOrgForm.phone || ""} onChange={e => setMyOrgForm(p => ({ ...p, phone: e.target.value }))} /></div>
                    <div className="adm-field"><label className="adm-label">Website</label>
                      <input className="adm-input" value={myOrgForm.website || ""} onChange={e => setMyOrgForm(p => ({ ...p, website: e.target.value }))} /></div>
                  </div>

                  <div className="adm-card-title" style={{marginTop:24}}>Registration & Payroll (Oman WPS)</div>
                  <div className="adm-form-grid">
                    <div className="adm-field"><label className="adm-label">Commercial Registration Number</label>
                      <input className="adm-input" value={myOrgForm.commercial_registration_number || ""} onChange={e => setMyOrgForm(p => ({ ...p, commercial_registration_number: e.target.value }))} /></div>
                    <div className="adm-field"><label className="adm-label">Ministry/Labour Establishment Number</label>
                      <input className="adm-input" value={myOrgForm.labour_establishment_number || ""} onChange={e => setMyOrgForm(p => ({ ...p, labour_establishment_number: e.target.value }))} /></div>
                    <div className="adm-field"><label className="adm-label">City</label>
                      <input className="adm-input" value={myOrgForm.city || ""} onChange={e => setMyOrgForm(p => ({ ...p, city: e.target.value }))} /></div>
                    <div className="adm-field"><label className="adm-label">Country</label>
                      <input className="adm-input" value={myOrgForm.country || ""} onChange={e => setMyOrgForm(p => ({ ...p, country: e.target.value }))} /></div>
                    <div className="adm-field"><label className="adm-label">Payroll Contact Person</label>
                      <input className="adm-input" value={myOrgForm.payroll_contact_person || ""} onChange={e => setMyOrgForm(p => ({ ...p, payroll_contact_person: e.target.value }))} /></div>
                    <div className="adm-field"><label className="adm-label">Default Currency</label>
                      <input className="adm-input" value={myOrgForm.default_currency || "OMR"} onChange={e => setMyOrgForm(p => ({ ...p, default_currency: e.target.value }))} /></div>
                    <div className="adm-field"><label className="adm-label">Default Payroll Working Days</label>
                      <input className="adm-input" type="number" min="0" value={myOrgForm.default_payroll_working_days || ""} onChange={e => setMyOrgForm(p => ({ ...p, default_payroll_working_days: +e.target.value }))} /></div>
                    <div className="adm-field"><label className="adm-label">Payroll Bank</label>
                      <input className="adm-input" value={myOrgForm.payroll_bank || ""} onChange={e => setMyOrgForm(p => ({ ...p, payroll_bank: e.target.value }))} /></div>
                    <div className="adm-field"><label className="adm-label">Company Bank Account Number</label>
                      <input className="adm-input" value={myOrgForm.company_bank_account_number || ""} onChange={e => setMyOrgForm(p => ({ ...p, company_bank_account_number: e.target.value }))} /></div>
                    <div className="adm-field"><label className="adm-label">Company IBAN</label>
                      <input className="adm-input" value={myOrgForm.company_iban || ""} onChange={e => setMyOrgForm(p => ({ ...p, company_iban: e.target.value }))} /></div>
                    <div className="adm-field"><label className="adm-label">WPS Bank Code</label>
                      <input className="adm-input" value={myOrgForm.wps_bank_code || ""} onChange={e => setMyOrgForm(p => ({ ...p, wps_bank_code: e.target.value }))} /></div>
                    <div className="adm-field"><label className="adm-label">WPS Bank Abbreviation</label>
                      <input className="adm-input" value={myOrgForm.wps_bank_abbreviation || ""} onChange={e => setMyOrgForm(p => ({ ...p, wps_bank_abbreviation: e.target.value }))} /></div>
                    <div className="adm-field"><label className="adm-label">Employer / Payer Identification</label>
                      <input className="adm-input" value={myOrgForm.employer_payer_identification || ""} onChange={e => setMyOrgForm(p => ({ ...p, employer_payer_identification: e.target.value }))} /></div>
                  </div>

                  <div style={{marginTop:16}}><button className="adm-submit" onClick={saveMyOrg}>Save Company Profile</button></div>
                </>
              )}
            </div>
          )}

          {/* ── Organisations (super_admin only) ── */}
          {TABS[tab] === "Organisations" && isSuperAdmin && (
            <>
              <div className="adm-card">
                <div className="adm-card-title">
                  All Organisations ({orgs.length})
                  <button className="adm-section-btn" onClick={() => { setOrgAction({ type:"add" }); setOrgForm({}); }}>+ Add Organisation</button>
                </div>
                <div className="adm-table-wrap">
                  <table className="adm-table" style={{minWidth:700}}>
                    <thead><tr><th>Name</th><th>Contact</th><th>Agents</th><th>Status</th><th>Actions</th></tr></thead>
                    <tbody>
                      {orgs.map(org => {
                        const agents = [org.access_bizcard&&"Bizcard", org.access_email&&"Email", org.access_compliance&&"Compliance", org.access_expense&&"Expense", org.access_hrms&&"HRMS", org.access_bni&&"BNI"].filter(Boolean);
                        return (
                          <tr key={org.id}>
                            <td style={{color:"#0d1a36",fontWeight:500}}>{org.name}</td>
                            <td>{org.contact_name || "—"}{org.contact_email ? ` (${org.contact_email})` : ""}</td>
                            <td style={{fontSize:11,color:"#6080aa"}}>{agents.join(", ") || "None"}</td>
                            <td><Badge label={org.is_active!==false?"active":"suspended"} type={org.is_active!==false?"active":"inactive"} colorMap={STATUS_COLOR}/></td>
                            <td>
                              <button className="adm-action-btn" onClick={() => { setOrgAction({type:"edit",org}); setOrgForm({name:org.name,contact_name:org.contact_name||"",contact_email:org.contact_email||"",phone:org.phone||"",website:org.website||""}); }}>Edit</button>
                              <button className="adm-action-btn" onClick={() => { setOrgAction({type:"access",org}); setOrgForm({access_bizcard:!!org.access_bizcard,access_email:!!org.access_email,access_compliance:!!org.access_compliance,access_expense:!!org.access_expense,access_hrms:!!org.access_hrms,access_bni:!!org.access_bni}); }}>Access</button>
                              <button className="adm-action-btn" onClick={() => { setOrgAction({type:"limits",org}); setOrgForm({limit_max_users:org.limit_max_users||0}); }}>Limits</button>
                              <button className="adm-action-btn" onClick={() => orgToggleSuspend(org)}>{org.is_active!==false?"Suspend":"Activate"}</button>
                              <button className="adm-action-btn danger" onClick={() => orgDelete(org)}>Delete</button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Inline action panels */}
              {orgAction && (
                <div className="adm-inline-form">
                  {(orgAction.type === "add" || orgAction.type === "edit") && (
                    <>
                      <div className="adm-inline-form-title">{orgAction.type === "add" ? "Add Organisation" : `Edit — ${orgAction.org?.name}`}</div>
                      <div className="adm-form-grid">
                        <div className="adm-field"><label className="adm-label">Name *</label><input className="adm-input" value={orgForm.name||""} onChange={e => setOrgForm(p=>({...p,name:e.target.value}))}/></div>
                        <div className="adm-field"><label className="adm-label">Contact Person</label><input className="adm-input" value={orgForm.contact_name||""} onChange={e => setOrgForm(p=>({...p,contact_name:e.target.value}))}/></div>
                        <div className="adm-field"><label className="adm-label">Contact Email</label><input className="adm-input" value={orgForm.contact_email||""} onChange={e => setOrgForm(p=>({...p,contact_email:e.target.value}))}/></div>
                        <div className="adm-field"><label className="adm-label">Phone</label><input className="adm-input" value={orgForm.phone||""} onChange={e => setOrgForm(p=>({...p,phone:e.target.value}))}/></div>
                        <div className="adm-field adm-form-grid" style={{gridColumn:"1/-1"}}><label className="adm-label">Website</label><input className="adm-input" value={orgForm.website||""} onChange={e => setOrgForm(p=>({...p,website:e.target.value}))}/></div>
                      </div>
                      <div style={{display:"flex",gap:10,marginTop:16}}>
                        <button className="adm-submit" onClick={orgSave}>Save</button>
                        <button className="adm-action-btn" onClick={() => { setOrgAction(null); setOrgForm({}); }}>Cancel</button>
                      </div>
                    </>
                  )}

                  {orgAction.type === "access" && (
                    <>
                      <div className="adm-inline-form-title">Agent Access — {orgAction.org.name}</div>
                      {[["access_bizcard","Business Card Agent"],["access_email","Email & Tender Agent"],["access_compliance","Compliance Bidding Agent"],["access_expense","Personal Expense Manager"],["access_hrms","HRMS & Payroll"],["access_bni","BNI Chapter Advisor"]].map(([field,label]) => (
                        <div className="adm-access-row" key={field}>
                          <span className="adm-access-label">{label}</span>
                          <button className={`adm-action-btn${orgForm[field]?" active-btn":""}`}
                            onClick={() => setOrgForm(p => ({...p,[field]:!p[field]}))}>
                            {orgForm[field] ? "Granted" : "Revoked"}
                          </button>
                        </div>
                      ))}
                      <div style={{display:"flex",gap:10,marginTop:16}}>
                        <button className="adm-submit" onClick={orgSave}>Save Access</button>
                        <button className="adm-action-btn" onClick={() => { setOrgAction(null); setOrgForm({}); }}>Cancel</button>
                      </div>
                    </>
                  )}

                  {orgAction.type === "limits" && (
                    <>
                      <div className="adm-inline-form-title">Usage Limits — {orgAction.org.name} (0 = unlimited)</div>
                      <div className="adm-form-grid">
                        <div className="adm-field"><label className="adm-label">Max Users</label><input className="adm-input" type="number" min="0" value={orgForm.limit_max_users||0} onChange={e => setOrgForm(p=>({...p,limit_max_users:+e.target.value}))}/></div>
                      </div>
                      <div style={{display:"flex",gap:10,marginTop:16}}>
                        <button className="adm-submit" onClick={orgSave}>Save Limits</button>
                        <button className="adm-action-btn" onClick={() => { setOrgAction(null); setOrgForm({}); }}>Cancel</button>
                      </div>
                    </>
                  )}
                </div>
              )}
            </>
          )}

          {/* ── Users ── */}
          {TABS[tab] === "Users" && (
            <>
              <div className="adm-card">
                <div className="adm-card-title">
                  All Users ({users.length})
                  <button className="adm-section-btn" onClick={() => {
                    setShowAddUser(s => !s);
                    setNewUser({ name:"", email:"", org_id: orgs[0]?.id||"", role:"user", access_bizcard:true, access_email:true, access_compliance:true, access_expense:true, access_hrms:true, access_bni:true });
                  }}>+ Add User</button>
                </div>
                <div className="adm-table-wrap">
                  <table className="adm-table" style={{minWidth:720}}>
                    <thead><tr><th>Name</th><th>Email</th>{isSuperAdmin&&<th>Organisation</th>}<th>Role</th><th>Status</th><th>Actions</th></tr></thead>
                    <tbody>
                      {users.map(u => (
                        <tr key={u.id}>
                          <td style={{color:"#0d1a36",fontWeight:500}}>{u.name||"—"}</td>
                          <td>{u.email}</td>
                          {isSuperAdmin && <td>{u.organisations?.name||"—"}</td>}
                          <td><Badge label={u.role} type={u.role} colorMap={ROLE_COLOR}/></td>
                          <td><Badge label={u.is_active!==false?"active":"inactive"} type={u.is_active!==false?"active":"inactive"} colorMap={STATUS_COLOR}/></td>
                          <td>
                            <button className="adm-action-btn" onClick={() => setEditingUser({...u})}>Edit</button>
                            <button className="adm-action-btn" onClick={() => toggleUserStatus(u)}>{u.is_active!==false?"Suspend":"Activate"}</button>
                            <button className="adm-action-btn danger" onClick={() => deleteUser(u)}>Remove</button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Add User form */}
              {showAddUser && (
                <div className="adm-inline-form">
                  <div className="adm-inline-form-title">Invite New User</div>
                  <div className="adm-form-grid">
                    <div className="adm-field"><label className="adm-label">Full Name</label><input className="adm-input" placeholder="Name" value={newUser.name} onChange={e => setNewUser(p=>({...p,name:e.target.value}))}/></div>
                    <div className="adm-field"><label className="adm-label">Email *</label><input className="adm-input" type="email" placeholder="user@example.com" value={newUser.email} onChange={e => setNewUser(p=>({...p,email:e.target.value}))}/></div>
                    {isSuperAdmin && (
                      <div className="adm-field">
                        <label className="adm-label">Organisation</label>
                        <select className="adm-select" value={newUser.org_id} onChange={e => {
                          const oid = e.target.value;
                          const oa = getOrgAccess(oid);
                          setNewUser(p=>({...p, org_id:oid,
                            access_bizcard:    p.access_bizcard    && !!oa.access_bizcard,
                            access_email:      p.access_email      && !!oa.access_email,
                            access_compliance: p.access_compliance && !!oa.access_compliance,
                            access_expense:    p.access_expense    && !!oa.access_expense,
                            access_hrms:       p.access_hrms       && !!oa.access_hrms,
                            access_bni:        p.access_bni        && !!oa.access_bni,
                          }));
                        }}>
                          {orgs.map(o => <option key={o.id} value={o.id}>{o.name}</option>)}
                        </select>
                      </div>
                    )}
                    <div className="adm-field">
                      <label className="adm-label">Role</label>
                      <select className="adm-select" value={newUser.role} onChange={e => setNewUser(p=>({...p,role:e.target.value}))}>
                        <option value="user">User</option><option value="admin">Admin</option>
                        <option value="hr_admin">HR Admin</option><option value="payroll_approver">Payroll/Finance Approver</option><option value="viewer_auditor">Viewer/Auditor</option>
                        {isSuperAdmin && <option value="super_admin">Super Admin</option>}
                      </select>
                    </div>
                  </div>
                  <div style={{marginTop:14}}>
                    <div className="adm-label" style={{marginBottom:8}}>Agent Access</div>
                    <div style={{display:"flex",flexWrap:"wrap",gap:14}}>
                      {(() => { const oa = getOrgAccess(newUser.org_id); return [["access_bizcard","Business Card"],["access_email","Email & Tender"],["access_compliance","Compliance"],["access_expense","Expense Manager"],["access_hrms","HRMS & Payroll"],["access_bni","BNI Chapter Advisor"]].map(([k,l]) => {
                        const allowed = !!oa[k];
                        return (
                          <label key={k} className="adm-checkbox-row" style={!allowed?{opacity:.4,cursor:'not-allowed',userSelect:'none'}:{}}>
                            <input type="checkbox" checked={newUser[k] && allowed} disabled={!allowed} onChange={e => setNewUser(p=>({...p,[k]:e.target.checked}))}/>
                            {l}{!allowed && <span style={{fontSize:10,color:'#6080aa',marginLeft:4}}>(org restricted)</span>}
                          </label>
                        );
                      }); })()}
                    </div>
                  </div>
                  <div style={{display:"flex",gap:10,marginTop:16}}>
                    <button className="adm-submit" onClick={addUser}>Add User</button>
                    <button className="adm-action-btn" onClick={() => setShowAddUser(false)}>Cancel</button>
                  </div>
                </div>
              )}

              {/* Edit User form */}
              {editingUser && (
                <div className="adm-inline-form">
                  <div className="adm-inline-form-title">Edit User — {editingUser.email}</div>
                  <div className="adm-form-grid">
                    <div className="adm-field"><label className="adm-label">Name</label><input className="adm-input" value={editingUser.name||""} onChange={e => setEditingUser(p=>({...p,name:e.target.value}))}/></div>
                    {isSuperAdmin && (
                      <div className="adm-field">
                        <label className="adm-label">Organisation</label>
                        <select className="adm-select" value={editingUser.org_id||""} onChange={e => setEditingUser(p=>({...p,org_id:e.target.value}))}>
                          {orgs.map(o => <option key={o.id} value={o.id}>{o.name}</option>)}
                        </select>
                      </div>
                    )}
                    <div className="adm-field">
                      <label className="adm-label">Role</label>
                      <select className="adm-select" value={editingUser.role||"user"} onChange={e => setEditingUser(p=>({...p,role:e.target.value}))}>
                        <option value="user">User</option><option value="admin">Admin</option>
                        <option value="hr_admin">HR Admin</option><option value="payroll_approver">Payroll/Finance Approver</option><option value="viewer_auditor">Viewer/Auditor</option>
                        {isSuperAdmin && <option value="super_admin">Super Admin</option>}
                      </select>
                    </div>
                  </div>
                  <div style={{marginTop:14}}>
                    <div className="adm-label" style={{marginBottom:8}}>Agent Access</div>
                    <div style={{display:"flex",flexWrap:"wrap",gap:14}}>
                      {(() => { const oa = editingUser.organisations || {}; return [["access_bizcard","Business Card"],["access_email","Email & Tender"],["access_compliance","Compliance"],["access_expense","Expense Manager"],["access_hrms","HRMS & Payroll"],["access_bni","BNI Chapter Advisor"]].map(([k,l]) => {
                        const allowed = oa[k] !== false;
                        return (
                          <label key={k} className="adm-checkbox-row" style={!allowed?{opacity:.4,cursor:'not-allowed',userSelect:'none'}:{}}>
                            <input type="checkbox" checked={!!editingUser[k] && allowed} disabled={!allowed} onChange={e => setEditingUser(p=>({...p,[k]:e.target.checked}))}/>
                            {l}{!allowed && <span style={{fontSize:10,color:'#6080aa',marginLeft:4}}>(org restricted)</span>}
                          </label>
                        );
                      }); })()}
                    </div>
                  </div>
                  <div style={{display:"flex",gap:10,marginTop:16}}>
                    <button className="adm-submit" onClick={saveUser}>Save User</button>
                    <button className="adm-action-btn" onClick={() => setEditingUser(null)}>Cancel</button>
                  </div>
                </div>
              )}
            </>
          )}

          {/* ── Usage ── */}
          {TABS[tab] === "Usage" && (
            usage.length === 0
              ? <div className="adm-empty">No usage data recorded this month.</div>
              : usage.map(o => {
                return (
                  <div className="adm-card" key={o.id}>
                    <div className="adm-card-title">{o.name}</div>
                    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14,marginBottom:16}}>
                      <div>
                        <div style={{fontSize:11,color:"#6080aa",fontWeight:600,textTransform:"uppercase",letterSpacing:".05em",marginBottom:6}}>Tokens Used</div>
                        <div style={{fontSize:20,fontWeight:700,color:"#0d1a36",fontVariantNumeric:"tabular-nums"}}>{o.tokens.toLocaleString()}</div>
                      </div>
                      <div>
                        <div style={{fontSize:11,color:"#6080aa",fontWeight:600,textTransform:"uppercase",letterSpacing:".05em",marginBottom:6}}>Requests</div>
                        <div style={{fontSize:20,fontWeight:700,color:"#0d1a36",fontVariantNumeric:"tabular-nums"}}>{o.requests.toLocaleString()}</div>
                      </div>
                    </div>
                    {o.per_user?.length > 0 && (
                      <>
                        <div style={{fontSize:11,color:"#6080aa",fontWeight:600,textTransform:"uppercase",letterSpacing:".05em",marginBottom:10}}>Per-user breakdown</div>
                        <div className="adm-table-wrap">
                          <table className="adm-table">
                            <thead><tr><th>User</th><th>Agent</th><th>Tokens</th><th>Requests</th></tr></thead>
                            <tbody>
                              {o.per_user.map((r,i) => (
                                <tr key={i}>
                                  <td style={{color:"#0d1a36"}}>{r.name} <span style={{color:"#6080aa",fontSize:11}}>({r.email})</span></td>
                                  <td>{r.agent}</td>
                                  <td style={{fontVariantNumeric:"tabular-nums"}}>{parseInt(r.tokens).toLocaleString()}</td>
                                  <td style={{fontVariantNumeric:"tabular-nums"}}>{parseInt(r.requests).toLocaleString()}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </>
                    )}
                  </div>
                );
              })
          )}

          {/* ── Audit Logs ── */}
          {TABS[tab] === "Audit Logs" && (
            <div className="adm-card">
              <div className="adm-card-title">
                Audit Logs
                <div style={{display:"flex",gap:10,alignItems:"center"}}>
                  <select className="adm-select" style={{fontSize:12,padding:"5px 10px"}} value={auditAction} onChange={e => setAuditAction(e.target.value)}>
                    <option value="">All Actions</option>
                    {Object.entries(ACTION_LABELS).map(([k,v]) => <option key={k} value={k}>{v}</option>)}
                  </select>
                  <select className="adm-select" style={{fontSize:12,padding:"5px 10px"}} value={auditLimit} onChange={e => setAuditLimit(+e.target.value)}>
                    {[50,100,200,500].map(n => <option key={n} value={n}>{n} rows</option>)}
                  </select>
                  <button className="adm-section-btn" onClick={loadLogs}>Refresh</button>
                </div>
              </div>
              {logs.length === 0
                ? <div className="adm-empty">No audit log entries found.</div>
                : logs.map((l, i) => (
                  <div className="adm-log-row" key={i}>
                    <span className="adm-log-time">{l.created_at}</span>
                    <span className="adm-log-action">{ACTION_LABELS[l.action] || l.action}</span>
                    <div style={{flex:1}}>
                      <div className="adm-log-msg">
                        {l.target_type && <span style={{color:"#6080aa"}}>{l.target_type}: </span>}
                        <span>{l.target_name || "—"}</span>
                        {l.details && <span style={{color:"#6080aa",fontSize:11,marginLeft:8}}>{JSON.stringify(l.details)}</span>}
                      </div>
                      <div className="adm-log-user">by {l.actor_email || "system"}</div>
                    </div>
                  </div>
                ))
              }
            </div>
          )}

          {/* ── Billing (org-facing) ── */}
          {TABS[tab] === "Billing" && (
            <>
              {wallet && wallet.status !== "ok" && (
                <div className={wallet.status === "exhausted" ? "adm-error" : "adm-error"} style={wallet.status === "low" ? { background: "rgba(245,158,11,.08)", border: "1px solid rgba(245,158,11,.25)", color: "#b45309" } : {}}>
                  &#9888; {wallet.status === "exhausted"
                    ? "AI credits exhausted — AI agents will not run until you top up."
                    : wallet.status === "critical"
                      ? `Critical: ${wallet.usage_pct}% of your AI credits used.`
                      : `Low credits: ${wallet.usage_pct}% used.`}
                </div>
              )}

              <div className="adm-metrics">
                <div className="adm-metric">
                  <div className="adm-metric-label">Credits Allocated</div>
                  <div className="adm-metric-value" style={{color:"#2563eb"}}>{wallet ? wallet.total_credits.toLocaleString() : "—"}</div>
                </div>
                <div className="adm-metric">
                  <div className="adm-metric-label">Credits Used</div>
                  <div className="adm-metric-value" style={{color:"#b45309"}}>{wallet ? wallet.used_credits.toLocaleString() : "—"}</div>
                  <div className="adm-metric-sub">{wallet ? `${wallet.usage_pct}%` : ""}</div>
                </div>
                <div className="adm-metric">
                  <div className="adm-metric-label">Credits Remaining</div>
                  <div className="adm-metric-value" style={{color:"#059669"}}>{wallet ? wallet.remaining_credits.toLocaleString() : "—"}</div>
                </div>
                <div className="adm-metric">
                  <div className="adm-metric-label">Requests This Month</div>
                  <div className="adm-metric-value">{wallet ? wallet.requests_this_month : "—"}</div>
                  <div className="adm-metric-sub">{wallet?.last_topup_date ? `Last top-up: ${wallet.last_topup_date.slice(0,10)}` : "No top-ups yet"}</div>
                </div>
              </div>

              <div className="adm-inline-form">
                <div className="adm-inline-form-title">Request Credit Top-Up</div>
                <div className="adm-form-grid">
                  <div className="adm-field"><label className="adm-label">Requested Credits</label>
                    <input className="adm-input" type="number" min="0" value={topupAmount} onChange={e => setTopupAmount(e.target.value)} placeholder="e.g. 100000"/>
                  </div>
                  <div className="adm-field"><label className="adm-label">Remarks (optional)</label>
                    <input className="adm-input" value={topupRemarks} onChange={e => setTopupRemarks(e.target.value)}/>
                  </div>
                </div>
                <div style={{marginTop:16}}>
                  <button className="adm-submit" onClick={submitTopup}>Submit Request</button>
                </div>
              </div>

              <div className="adm-card">
                <div className="adm-card-title">Your Top-Up Requests</div>
                {topups.length === 0
                  ? <div className="adm-empty">No top-up requests yet.</div>
                  : (
                    <div className="adm-table-wrap">
                      <table className="adm-table">
                        <thead><tr><th>Requested</th><th>Credits</th><th>Status</th><th>Remarks</th></tr></thead>
                        <tbody>
                          {topups.map(t => (
                            <tr key={t.id}>
                              <td>{t.requested_at?.slice(0,19).replace("T"," ")}</td>
                              <td style={{fontVariantNumeric:"tabular-nums"}}>{Number(t.requested_credits).toLocaleString()}</td>
                              <td><Badge label={t.status} type={t.status === "completed" ? "active" : t.status === "rejected" ? "inactive" : "user"} colorMap={STATUS_COLOR}/></td>
                              <td>{t.remarks || "—"}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
              </div>
            </>
          )}

          {/* ── AI Pricing (super_admin only) ── */}
          {TABS[tab] === "AI Pricing" && isSuperAdmin && (
            <>
              <div className="adm-inline-form">
                <div className="adm-inline-form-title">Global Pricing Settings</div>
                <div className="adm-form-grid">
                  <div className="adm-field"><label className="adm-label">Global Cost Multiplier</label>
                    <input className="adm-input" type="number" step="0.01" min="0"
                      value={pricingDraft.global_cost_multiplier}
                      onChange={e => setPricingDraft(p => ({...p, global_cost_multiplier: e.target.value}))}/>
                  </div>
                  <div className="adm-field"><label className="adm-label">AI Credit Conversion Rate (credits per 1 OMR)</label>
                    <input className="adm-input" type="number" step="1" min="0"
                      value={pricingDraft.credit_conversion_rate}
                      onChange={e => setPricingDraft(p => ({...p, credit_conversion_rate: e.target.value}))}/>
                  </div>
                  <div className="adm-field"><label className="adm-label">Default GPT Model (used when an agent has no model set)</label>
                    <select className="adm-input" value={pricingDraft.default_model}
                      onChange={e => setPricingDraft(p => ({...p, default_model: e.target.value}))}>
                      {!MODEL_OPTIONS.includes(pricingDraft.default_model) && pricingDraft.default_model &&
                        <option value={pricingDraft.default_model}>{pricingDraft.default_model}</option>}
                      {MODEL_OPTIONS.map(m => <option key={m} value={m}>{m}</option>)}
                    </select>
                    <ModelPriceHint model={pricingDraft.default_model} />
                  </div>
                  <div className="adm-field"><label className="adm-label">USD to OMR Exchange Rate</label>
                    <input className="adm-input" type="number" step="0.0001" min="0"
                      value={pricingDraft.usd_to_omr_rate}
                      onChange={e => setPricingDraft(p => ({...p, usd_to_omr_rate: e.target.value}))}/>
                  </div>
                </div>
                <div style={{marginTop:16}}><button className="adm-submit" onClick={savePricing}>Save</button></div>
              </div>

              <div className="adm-card">
                <div className="adm-card-title">Organisation Multiplier Overrides</div>
                {!pricing?.organization_overrides || pricing.organization_overrides.length === 0
                  ? <div className="adm-empty">No organisation-specific overrides set. All organisations use the global multiplier. Set an override from the Credit Wallets tab.</div>
                  : (
                    <div className="adm-table-wrap">
                      <table className="adm-table">
                        <thead><tr><th>Organisation</th><th>Cost Multiplier</th></tr></thead>
                        <tbody>
                          {pricing.organization_overrides.map(o => (
                            <tr key={o.org_id}><td>{o.org_name}</td><td>{o.cost_multiplier}</td></tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
              </div>
            </>
          )}

          {/* ── AI Agents (super_admin only) ── */}
          {TABS[tab] === "AI Agents" && isSuperAdmin && (
            <div className="adm-card">
              <div className="adm-card-title">Agent Configuration</div>
              {agentConfigs.length === 0
                ? <div className="adm-empty">No agents configured.</div>
                : (
                  <div className="adm-table-wrap">
                    <table className="adm-table" style={{minWidth:820}}>
                      <thead><tr><th>Agent</th><th>GPT Model</th><th>Max Tokens/Request</th><th>Cost Multiplier</th><th>Status</th><th>Actions</th></tr></thead>
                      <tbody>
                        {agentConfigs.map(a => {
                          const d = agentDrafts[a.agent_slug] || {};
                          return (
                            <tr key={a.agent_slug}>
                              <td style={{color:"#0d1a36",fontWeight:500}}>{a.display_name}</td>
                              <td>
                                <select className="adm-input" style={{padding:"6px 9px",width:150}} value={d.model_name}
                                    onChange={e => setAgentDrafts(p => ({...p, [a.agent_slug]: {...p[a.agent_slug], model_name: e.target.value}}))}>
                                  <option value="">(use default)</option>
                                  {!MODEL_OPTIONS.includes(d.model_name) && d.model_name &&
                                    <option value={d.model_name}>{d.model_name}</option>}
                                  {MODEL_OPTIONS.map(m => <option key={m} value={m}>{m}</option>)}
                                </select>
                                <ModelPriceHint model={d.model_name} />
                              </td>
                              <td><input className="adm-input" style={{padding:"6px 9px",width:100}} type="number" min="0" value={d.max_tokens_per_request}
                                    onChange={e => setAgentDrafts(p => ({...p, [a.agent_slug]: {...p[a.agent_slug], max_tokens_per_request: e.target.value}}))}/></td>
                              <td><input className="adm-input" style={{padding:"6px 9px",width:90}} type="number" step="0.01" min="0" placeholder="global" value={d.default_cost_multiplier}
                                    onChange={e => setAgentDrafts(p => ({...p, [a.agent_slug]: {...p[a.agent_slug], default_cost_multiplier: e.target.value}}))}/></td>
                              <td>
                                <select className="adm-select" style={{padding:"6px 9px"}} value={d.status}
                                  onChange={e => setAgentDrafts(p => ({...p, [a.agent_slug]: {...p[a.agent_slug], status: e.target.value}}))}>
                                  <option value="active">Active</option>
                                  <option value="inactive">Inactive</option>
                                </select>
                              </td>
                              <td><button className="adm-action-btn" onClick={() => saveAgentConfig(a.agent_slug)}>Save</button></td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
            </div>
          )}

          {/* ── Credit Wallets (super_admin only) ── */}
          {TABS[tab] === "Credit Wallets" && isSuperAdmin && (
            <>
              <div className="adm-card">
                <div className="adm-card-title">
                  Organisation Wallets ({allWallets.length})
                  <button className="adm-section-btn" onClick={() => exportCSV(
                    "organisation_wallets.csv",
                    [
                      {key:"org_name", label:"Organisation"}, {key:"total_credits", label:"Allocated"},
                      {key:"used_credits", label:"Used"}, {key:"remaining_credits", label:"Remaining"},
                      {key:"usage_pct", label:"Usage %"}, {key:"cost_multiplier", label:"Multiplier"},
                    ],
                    allWallets,
                  )}>Export CSV</button>
                </div>
                <div className="adm-table-wrap">
                  <table className="adm-table" style={{minWidth:760}}>
                    <thead><tr><th>Organisation</th><th>Allocated</th><th>Used</th><th>Remaining</th><th>Usage %</th><th>Multiplier</th><th>Actions</th></tr></thead>
                    <tbody>
                      {allWallets.map(w => (
                        <Fragment key={w.org_id}>
                          <tr>
                            <td style={{color:"#0d1a36",fontWeight:500}}>{w.org_name}</td>
                            <td style={{fontVariantNumeric:"tabular-nums"}}>{w.total_credits.toLocaleString()}</td>
                            <td style={{fontVariantNumeric:"tabular-nums"}}>{w.used_credits.toLocaleString()}</td>
                            <td style={{fontVariantNumeric:"tabular-nums"}}>{w.remaining_credits.toLocaleString()}</td>
                            <td>{w.usage_pct}%</td>
                            <td>{w.cost_multiplier ?? "global"}</td>
                            <td>
                              <button className="adm-action-btn" onClick={() => setOrgMultiplier(w.org_id, w.cost_multiplier)}>Set Multiplier</button>
                              <button className="adm-action-btn" onClick={() => adjustWallet(w.org_id, "allocate")}>Allocate</button>
                              <button className="adm-action-btn" onClick={() => adjustWallet(w.org_id, "reduce")}>Reduce</button>
                              <button className="adm-action-btn danger" onClick={() => adjustWallet(w.org_id, "reset")}>Reset</button>
                              <button className="adm-action-btn" onClick={() => viewWalletHistory(w.org_id)}>{historyOrgId === w.org_id ? "Hide History" : "History"}</button>
                            </td>
                          </tr>
                          {historyOrgId === w.org_id && (
                            <tr key={`${w.org_id}-history`}>
                              <td colSpan={7} style={{background:"#f8faff",padding:16}}>
                                {walletHistory.length === 0
                                  ? <div className="adm-empty">No history recorded for this organisation yet.</div>
                                  : (
                                    <table className="adm-table">
                                      <thead><tr><th>Date</th><th>Action</th><th>Amount</th><th>Total After</th><th>Used After</th><th>By</th><th>Notes</th></tr></thead>
                                      <tbody>
                                        {walletHistory.map(h => (
                                          <tr key={h.id}>
                                            <td>{h.created_at}</td>
                                            <td>{h.action}</td>
                                            <td style={{fontVariantNumeric:"tabular-nums"}}>{h.amount != null ? Number(h.amount).toLocaleString() : "—"}</td>
                                            <td style={{fontVariantNumeric:"tabular-nums"}}>{Number(h.resulting_total_credits).toLocaleString()}</td>
                                            <td style={{fontVariantNumeric:"tabular-nums"}}>{Number(h.resulting_used_credits).toLocaleString()}</td>
                                            <td>{h.performed_by_name || h.performed_by_email || "—"}</td>
                                            <td>{h.notes || "—"}</td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  )}
                              </td>
                            </tr>
                          )}
                        </Fragment>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="adm-card">
                <div className="adm-card-title">Top-Up Approval Queue</div>
                {allTopups.filter(t => t.status === "pending").length === 0
                  ? <div className="adm-empty">No pending top-up requests.</div>
                  : (
                    <div className="adm-table-wrap">
                      <table className="adm-table" style={{minWidth:600}}>
                        <thead><tr><th>Organisation</th><th>Requested</th><th>Credits</th><th>Remarks</th><th>Actions</th></tr></thead>
                        <tbody>
                          {allTopups.filter(t => t.status === "pending").map(t => (
                            <tr key={t.id}>
                              <td>{t.org_name}</td>
                              <td>{t.requested_at?.slice(0,19).replace("T"," ")}</td>
                              <td style={{fontVariantNumeric:"tabular-nums"}}>{Number(t.requested_credits).toLocaleString()}</td>
                              <td>{t.remarks || "—"}</td>
                              <td>
                                <button className="adm-action-btn active-btn" onClick={() => approveTopup(t.id)}>Approve</button>
                                <button className="adm-action-btn danger" onClick={() => rejectTopup(t.id)}>Reject</button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
              </div>
            </>
          )}

          {/* ── AI Dashboard: Platform/User/Agent Summary + raw Usage Logs (super_admin only) ── */}
          {TABS[tab] === "AI Dashboard" && isSuperAdmin && (
            <>
              <div className="adm-metrics">
                <div className="adm-metric">
                  <div className="adm-metric-label">Total OpenAI Spend</div>
                  <div className="adm-metric-value" style={{color:"#dc2626"}}>{platformSummary ? `$${platformSummary.total_openai_spend.toFixed(2)}` : "—"}</div>
                </div>
                <div className="adm-metric">
                  <div className="adm-metric-label">Credits Allocated</div>
                  <div className="adm-metric-value" style={{color:"#2563eb"}}>{platformSummary ? platformSummary.total_credits_allocated.toLocaleString() : "—"}</div>
                </div>
                <div className="adm-metric">
                  <div className="adm-metric-label">Credits Consumed</div>
                  <div className="adm-metric-value" style={{color:"#b45309"}}>{platformSummary ? platformSummary.total_credits_consumed.toLocaleString() : "—"}</div>
                </div>
                <div className="adm-metric">
                  <div className="adm-metric-label">Remaining Credits</div>
                  <div className="adm-metric-value" style={{color:"#059669"}}>{platformSummary ? platformSummary.remaining_credits.toLocaleString() : "—"}</div>
                </div>
                <div className="adm-metric">
                  <div className="adm-metric-label">Total AI Requests</div>
                  <div className="adm-metric-value">{platformSummary ? platformSummary.total_ai_requests.toLocaleString() : "—"}</div>
                </div>
              </div>

              <div className="adm-card">
                <div className="adm-card-title">User Summary</div>
                {userSummary.length === 0
                  ? <div className="adm-empty">No usage logged yet.</div>
                  : (
                    <div className="adm-table-wrap">
                      <table className="adm-table" style={{minWidth:600}}>
                        <thead><tr><th>Organisation</th><th>User</th><th>Requests</th><th>Credits Used</th></tr></thead>
                        <tbody>
                          {userSummary.map((u,i) => (
                            <tr key={i}>
                              <td>{u.org_name}</td>
                              <td>{u.user_name} <span style={{color:"#6080aa",fontSize:11}}>({u.email})</span></td>
                              <td style={{fontVariantNumeric:"tabular-nums"}}>{Number(u.requests).toLocaleString()}</td>
                              <td style={{fontVariantNumeric:"tabular-nums"}}>{Number(u.credits_used).toFixed(2)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
              </div>

              <div className="adm-card">
                <div className="adm-card-title">Agent Summary</div>
                {agentSummary.length === 0
                  ? <div className="adm-empty">No usage logged yet.</div>
                  : (
                    <div className="adm-table-wrap">
                      <table className="adm-table" style={{minWidth:700}}>
                        <thead><tr><th>Agent</th><th>GPT Model</th><th>Requests</th><th>Tokens Used</th><th>OpenAI Cost</th><th>Credits Charged</th></tr></thead>
                        <tbody>
                          {agentSummary.map((a,i) => (
                            <tr key={i}>
                              <td>{a.agent_slug}</td>
                              <td>{a.model_name || "—"}</td>
                              <td style={{fontVariantNumeric:"tabular-nums"}}>{Number(a.requests).toLocaleString()}</td>
                              <td style={{fontVariantNumeric:"tabular-nums"}}>{Number(a.tokens_used).toLocaleString()}</td>
                              <td style={{fontVariantNumeric:"tabular-nums"}}>${Number(a.openai_cost).toFixed(4)}</td>
                              <td style={{fontVariantNumeric:"tabular-nums"}}>{Number(a.credits_charged).toFixed(2)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
              </div>

              <div className="adm-card">
                <div className="adm-card-title">
                  AI Usage Logs
                  <div style={{display:"flex",gap:8}}>
                    <button className="adm-section-btn" onClick={() => exportCSV(
                      "ai_usage_logs.csv",
                      [
                        {key:"created_at", label:"Date"}, {key:"org_name", label:"Organisation"},
                        {key:"user_name", label:"User"}, {key:"agent", label:"Agent"},
                        {key:"model_name", label:"Model"}, {key:"tokens_used", label:"Tokens"},
                        {key:"openai_cost", label:"OpenAI Cost"}, {key:"cost_multiplier", label:"Multiplier"},
                        {key:"credits_charged", label:"Credits Charged"},
                      ],
                      usageLogs,
                    )}>Export CSV</button>
                    <button className="adm-section-btn" onClick={loadUsageLogs}>Refresh</button>
                  </div>
                </div>
                {usageLogs.length === 0
                  ? <div className="adm-empty">No usage logged yet.</div>
                  : (
                    <div className="adm-table-wrap">
                      <table className="adm-table" style={{minWidth:900}}>
                        <thead><tr><th>Date</th><th>Organisation</th><th>User</th><th>Agent</th><th>Model</th><th>Tokens</th><th>OpenAI Cost</th><th>Multiplier</th><th>Credits Charged</th></tr></thead>
                        <tbody>
                          {usageLogs.map(l => (
                            <tr key={l.id}>
                              <td>{l.created_at}</td>
                              <td>{l.org_name || "—"}</td>
                              <td>{l.user_name || l.email || "—"}</td>
                              <td>{l.agent}</td>
                              <td>{l.model_name || "—"}</td>
                              <td style={{fontVariantNumeric:"tabular-nums"}}>{l.tokens_used?.toLocaleString?.() ?? l.tokens_used}</td>
                              <td style={{fontVariantNumeric:"tabular-nums"}}>{l.openai_cost != null ? `$${Number(l.openai_cost).toFixed(4)}` : "—"}</td>
                              <td>{l.cost_multiplier ?? "—"}</td>
                              <td style={{fontVariantNumeric:"tabular-nums"}}>{l.credits_charged != null ? Number(l.credits_charged).toFixed(2) : "—"}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
              </div>
            </>
          )}
        </>}
      </main>
    </>
  );
}
